export default __webpack_public_path__ + "static/media/IMG_2790 - Sourabh Singh.fb343efc.jpeg";